module.exports = __webpack_public_path__ + "static/media/exit2.32740f3e.svg";